import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { UserShareBudget } from 'app/model/user/user-share-budget';
import { TranslatePipe } from 'app/pipes/translate.pipe';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { AuthorizeService } from 'app/services/authorize/authorize.service';
import { UserService } from 'app/services/user/user.service';
import { frontend } from 'environments/properties';
import { Booker, ShareBudget } from './dialog-share-budget.model';

@Component({
  selector: 'act-dialog-share-budget',
  templateUrl: './dialog-share-budget.component.html',
  styleUrls: ['./dialog-share-budget.component.scss']
})
export class DialogShareBudgetComponent implements OnInit {

  public STATE = {
    VERIFY: 'VERIFY',
    CO_BOOKER_COMPANY: 'CO_BOOKER_COMPANY'
  };

  public state = this.STATE.VERIFY;
  public listCompany = [];
  public isSubmitted = false;
  public form: FormGroup;
  public isLoading = false;
  public copied = false;
  public budget: number;
  public coBookerUserId: number;
  public coBookerCompanyId: number;
  public coBookerAddress: string;
  public bookerNotAllowFeature = false;
  public expireDate: number;
  public link = '';

  private coBookerFullName: string;

  constructor(
    private dialogRef: MdDialogRef<DialogShareBudgetComponent>,
    private fb: FormBuilder,
    private authorizeService: AuthorizeService,
    private appConfigService: AppConfigService,
    private userService: UserService,
    private translate: TranslatePipe
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    document.documentElement.style.setProperty('--height-vh', `${window.innerHeight * 0.01}px`);
  }

  ngOnInit() {
    this.onResize();
    this.form = this.fb.group({
      codeRef: ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^[a-zA-Z0-9]+$/)]],
      coBookerEmail: [''],
      companyName: [''],
    });
    this.link = `${frontend}/share-budget-code`;
  }

  onContinue() {
    this.isSubmitted = true;
    switch (this.state) {
      case this.STATE.VERIFY:
        if (this.form.valid) {
          this.isLoading = true;
          this.authorizeService.shareBudgetCode(this.form.get('codeRef').value, this.userService.getUser().companyId, this.getLang())
            .subscribe((res: UserShareBudget) => {
              this.form.get('companyName').setValue(res.coBookerDetail.companyName);
              this.form.get('coBookerEmail').setValue(res.coBookerDetail.email);
              this.form.get('codeRef').disable();
              this.budget = res.coBookerDetail.budget;
              this.coBookerUserId = res.coBookerDetail.userId;
              this.coBookerCompanyId = res.coBookerDetail.companyId;
              this.coBookerFullName = res.coBookerDetail.fullName;
              this.coBookerAddress = `${this.translate.transform('dialog-share-budget-company')} ${res.coBookerDetail.taxAddress.name}<br>${this.translate.transform('dialog-share-budget-tax-id')} ${res.coBookerDetail.taxAddress.taxNumber}<br>${res.coBookerDetail.taxAddress.address}`;
              this.expireDate = res.expireDate;
              this.state = this.STATE.CO_BOOKER_COMPANY;
              this.isSubmitted = false;
              this.isLoading = false;
            }, err => {
              this.isLoading = false;
              try {
                const errors = err.json();
                if (errors && errors.errors && errors.errors.length > 0) {
                  const code = errors.errors[0].code;
                  switch (code) {
                    case "4701":
                      this.form.get('codeRef').setErrors({ incorrect: true });
                      break;
                    case "4702":
                      this.form.get('codeRef').setErrors({ expired: true });
                      break;
                    case "4703":
                      this.form.get('codeRef').setErrors({ yourself: true });
                      break;
                    case "4704":
                      // case booker not allow feature share budget
                      this.authorizeService.setCookieFeatureShareBudgetIsFalse();
                      this.bookerNotAllowFeature = true;
                      this.form.get('codeRef').setErrors({ notAllowFeature: true });
                      break;
                    case "4705":
                      this.form.get('codeRef').setErrors({ notAllowFeature: true });
                      break;
                    default:
                      this.form.get('codeRef').setErrors({ incorrect: true });
                      break;
                  }
                } else {
                  this.form.get('codeRef').setErrors({ incorrect: true });
                }
              } catch (error) {
                this.form.get('codeRef').setErrors({ incorrect: true });
              }
            });
        }
        break;
      case this.STATE.CO_BOOKER_COMPANY:
        if (this.form.valid) {
          this.isSubmitted = false;
          this.authorizeService.setCoBookerCookie(this.coBookerUserId, this.coBookerCompanyId, this.form.get('coBookerEmail').value, this.budget, this.coBookerFullName, this.expireDate, this.form.get('codeRef').value);
          this.authorizeService.setShareBudgetCodeCookie(this.form.get('codeRef').value);
          this.dialogRef.close({ event: 'success', shareBudget: new ShareBudget(undefined, new Booker(this.coBookerUserId, this.coBookerCompanyId, this.form.get('coBookerEmail').value, this.budget, this.coBookerFullName)) });
        }
        break;
    }
  }

  onChangeCodeRef() {
    this.form.get('codeRef').reset({ value: '', disabled: false });
    this.form.get('companyName').reset('');
    this.form.get('coBookerEmail').reset('');
    this.coBookerAddress = undefined;

    this.state = this.STATE.VERIFY;
    this.isSubmitted = false;
  }

  onClose() {
    if (this.bookerNotAllowFeature) {
      this.dialogRef.close({ event: 'bookerNotAllowFeature' });
    } else {
      this.form.get('codeRef').value === '' ? this.dialogRef.close({ event: 'closeDialog' }) : this.dialogRef.close({ event: 'close' });
    }
  }

  onCopyLink() {
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 5000);
  }

  getLang() {
    return this.appConfigService.getLanguage();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-share-budget/dialog-share-budget.component.ts